import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { TaxTxnsContainerModel } from '../../../../../../models/aggregates/erp/tax';



@Injectable({ providedIn: 'root' })
export class TaxTxnsService extends BaseApiTemplateService<TaxTxnsContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'tax-txns';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'tax-txns';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'tax-txns';
    this.httpClient = theHttp;
  }


}
